import { IUserServiceMock } from "./user.types";

export const mockUserService = (): IUserServiceMock => ({
  getLoggedUser: jest.fn(),
  getUsersPage: jest.fn(),
  saveUsersReport: jest.fn(),
  getUserDetail: jest.fn(),
  updateUser: jest.fn(),
  addUserServicepointApproval: jest.fn(),
  removeUserServicepoint: jest.fn(),
  removeUserServicepointApprovals: jest.fn(),
  toggleAdmin: jest.fn(),
  toggleSupervisor: jest.fn(),
  toggleAprobador: jest.fn(),
  acceptDisclaimer: jest.fn(),
  declineDisclaimer: jest.fn(),
  updateOIDSol: jest.fn(),
  syncUser: jest.fn(),
  toggleFlowApprovalNotification: jest.fn(),
});
